import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';

export interface NotificationItemDto {
  id?: string | number;
  senderId?: string | number;
  userId?: string | number;
  sender?: string;
  title?: string;
  message?: string | null;
  type?: string | null;
  targetType?: string | null;
  targetId?: string | number | null;
  icon?: string | null;
  isRead?: boolean;
  expiresAt?: string | null;
  createdAt?: string;
  createDate?: string;
  createdDate?: string;
  time?: string;
  imageUrl?: string | null;
  createUser?: string;
  lastUpdDate?: string;
  lastUpdUser?: string | null;
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  constructor(private api: ApiService) {}

  getNotifications(): Observable<NotificationItemDto[]> {
    return this.api.get<NotificationItemDto[]>('notifications');
  }

  getUnreadNotifications(): Observable<NotificationItemDto[]> {
    return this.api.get<NotificationItemDto[]>('notifications?isRead=false');
  }

  markAsRead(id: number | string): Observable<any> {
    return this.api.put(`notifications/${id}/read`, {});
  }

  markAllAsRead(userId?: number | string): Observable<any> {
    const params = userId ? `?userId=${userId}` : '';
    return this.api.put(`notifications/read-all${params}`, {});
  }

  deleteExpired(): Observable<any> {
    return this.api.delete('notifications/expired');
  }
}
